import * as Constants from './Constants';

const initialState = {
  title: 'CBandPlans',
  plansJson: '',
  plansAEM: '',
  selectedOption: '',
  planChanged: false,
  showError: false,
  planServiceinfo: null,
  invalidCaseError: false,
  plansError: false,
  plansNotifyMessage: null,
  showACPDetailModal: false,
  showVFDetailModal: false,
  fccContentValue: null,
  fccContentError: false,
  intialACPModalAutoload: false,
  intialVFModalAutoload: true,
  bannerValue: null,
  errorBanner: false,
};

function cBandPlans(state = initialState, action) {
  switch (action.type) {
    case 'C_BAND_PLANS_SUCCESS':
      return { ...state, plans: action.response };
    case 'C_BAND_PLANS_DETAILS_SUCCESS':
      return { ...state, plansDetails: action.response, promosUpdated: true };
    // PLAN_SELECTED_SUCCESS
    case Constants.PLAN_SELECTED:
      return { ...state, planSelected: action.response, planChanged: false };
    case Constants.UPDATE_SFO_DATA:
      return { ...state, updateSfoData: action.response };
    case 'PLAN_SELECTED_SUCCESS': {
      const preState = state.planChanged;
      return { ...state, planChanged: !preState };
    }
    case 'DAW_COUPON': {
      return { ...state, dawCoupon: action.value ? action.value : '' };
    }
    // return { ...state, update: action.response };
    case Constants.ERR_OCCURED:
      return {
        ...state,
        showError: action.response,
        planServiceinfo: action.serviceinfo,
        ...(action?.response?.cBandError ? { promosUpdated: true } : {}),
      };
    case Constants.INVALID_CASE_ERROR:
      return { ...state, invalidCaseError: action.response, planServiceinfo: action.serviceinfo };
    case Constants.RESET_PROMO_UPDATED:
      return { ...state, promosUpdated: false };
    case Constants.CEF_PLANS_ERROR:
      return { ...state, plansError: action.response, plansNotifyMessage: action.errorMessage };
    case Constants.TOGGLE_ACP_MODAL:
      return {
        ...state,
        showACPDetailModal: !state.showACPDetailModal,
        ...(state.intialACPModalAutoload && !state.showACPDetailModal ? { intialACPModalAutoload: false, showACPDetailModal: false } : {}),
      };
    case Constants.RESET_ACP_MODAL:
      return { ...state, showACPDetailModal: initialState.showACPDetailModal };
    case Constants.TOGGLE_VF_MODAL:
      return {
        ...state,
        showVFDetailModal: !state.showVFDetailModal,
        ...(state.intialVFModalAutoload && !state.showVFDetailModal ? { intialVFModalAutoload: false, showVFDetailModal: false } : {}),
      };
    case Constants.RESET_VF_MODAL:
      return { ...state, showVFDetailModal: initialState.showVFDetailModal };
    case Constants.FCC_LABEL_ERROR:
      return { ...state, fccContentError: true, fccContentValue: action.response };
    case Constants.FCC_LABEL_SUCCESS:
      return { ...state, fccContentError: false, fccContentValue: action.response };
    case Constants.UPDATE_ACPMODAL_AL_STATUS:
      return { ...state, intialACPModalAutoload: action.value };
    case Constants.UPDATE_VFMODAL_AL_STATUS:
      return { ...state, intialVFModalAutoload: action.value };
    case Constants.BANNER_PROMOTION_FLOW_VALUE:
      return { ...state, bannerValue: action.response, errorBanner: action.error };
    default:
      return state;
  }
}

export default cBandPlans;
